// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import React, { useState } from "react";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { auth, firestore } from "../../FirebaseConfig";



// const ProductCard = ({ data }) => {
//   const isDiscounted = data.prices.productDiscount > 0;
//   const isInStock = data.stock > 0;
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);

//   const handleProduct = () => {
//     navigate(`/product/${data.id}`);
//   };


//   const showCustomToast = (message) => {
//     toast.custom(
//       (t) => (
//         <div
//           className={`${
//             t.visible ? "animate-fadeIn" : "animate-fadeOut"
//           } bg-white shadow-xl text-black p-4 md:p-6 rounded-lg fixed top-1/2 left-1/2 
//           transform -translate-x-1/2 -translate-y-1/2 z-50 
//           w-full max-w-sm md:max-w-md lg:max-w-lg text-center`}
//         >
//           <p className="text-sm md:text-base lg:text-lg font-semibold">{message}</p>
//         </div>
//       ),
//       { duration: 3000 }
//     );
//   };

  


//   const handleAddToCart = async (product,id) => {
//     if (!auth.currentUser) {
//       toast.error("Please log in to add items to your cart.");
//       // alert("Please log in to add items to your cart.");
//       // navigate(`/login?redirect=/`);
//       return;
//     }

//     if ( product.stock<1) return;

//     // setAddingToCart(true);
//     const userId = auth.currentUser.uid;
//     const cartRef = doc(firestore, "customers", userId);
//     toast.loading("Adding Item .!");

//     try {
//       const cartSnap = await getDoc(cartRef);

//       if (cartSnap.exists()) {
//         const cartData = cartSnap.data();
//         let updatedCart = { ...cartData };

//         if (updatedCart.items) {
//           const existingItemIndex = updatedCart.items.findIndex(item => item.productId === id);

//           if (existingItemIndex !== -1) {
//             updatedCart.items[existingItemIndex].quantity += 1;
//           } else {
//             updatedCart.items.push({ productId: id, quantity:1 });
//           }
//         } else {
//           updatedCart = { items: [{ productId: id, quantity:1 }] };
//         }

//         await updateDoc(cartRef, updatedCart);
//       } else {
//         await setDoc(cartRef, { items: [{ productId: id, quantity:1 }] });
//       }
//       toast.dismiss();
//       toast.success("Item added to cart!");
//     } catch (error) {
//       toast.dismiss();

//       console.error("Error adding to cart:", error);
//       toast.error("Error adding item to cart. Please try again.");
//     }

//     // setAddingToCart(false);
//   };
//   return (
//     <div
//       onClick={handleProduct}
//       className="bg-white rounded-lg shadow-md hover:shadow-xl transition-transform cursor-pointer w-full max-w-[280px] pb-4"
//     >
//       {/* Discount Tag */}
//       {/* {isDiscounted && (
//         <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
//           SALE
//         </div>
//       )} */}

//       {/* Product Image with Shimmer Effect */}
//       <div className={`relative w-full flex justify-center items-center bg-gray-100 rounded-md ${
//         isLoading ? 'h-[200px]' : 'h-auto'}`}>
//         {/* Shimmer Effect - Only Visible While Loading */}
//         {isLoading && (
//           <div className="absolute inset-0 bg-gray-300 animate-pulse rounded-md"></div>
//         )}

//         {/* Actual Image */}
//         <img
//           src={data.thumbnail}
//           alt={data.name}
//           className={`w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
//             isLoading ? "opacity-0" : "opacity-100"
//           }`}
//           onLoad={() => setIsLoading(false)}
//           onError={() => setIsLoading(false)} // Fallback in case image fails to load
//         />

//         {/* Status Badge */}
//         {data.status !== "Normal" && (
//           <div
//             className={`absolute top-2 left-2 px-3 py-1 rounded-full text-xs font-semibold ${
//               isInStock ? "bg-red-500 text-white" : "bg-gray-400 text-white"
//             }`}
//           >
//             {isInStock ? data.status : "Out of Stock"}
//           </div>
//         )}
//       </div>

//       {/* Product Details */}
//       <div className="text-center px-2">
//         <h3 className="text-sm font-semibold text-gray-700 truncate">
//           {data.name}
//         </h3>
//         <p className="text-sm text-gray-600">{data.category}</p>

//         {/* Price Display */}
//         <div className="mt-2 flex items-center justify-center space-x-2">
//           {isDiscounted && (
//             <span className="text-gray-500 line-through text-sm">
//               ₹{data.prices.productPrice}
//             </span>
//           )}
//           <span className="text-orange-500 font-bold text-lg">
//             ₹{data.prices.productPrice - data.prices.productDiscount}
//           </span>
//         </div>

//         {/* Add to Cart Button */}
//         <button 
//   onClick={(e) => {
//     e.stopPropagation(); // Prevents navigation when clicking button
//     handleAddToCart(data, data.id);
//   }} 
//   className={`mt-3 px-4 py-2 rounded hover:${data.stock < 1 ? 'bg-gray-500' : 'bg-green-700'} ${data.stock < 1 ? 'bg-gray-600' : 'bg-green-600'} text-white`}
//   disabled={data.stock < 1}  // Optionally disable the button if stock is less than 1
// >
// {data.stock < 1 ? 'Out Of Stock' : 'Add 🍯'}</button>

//       </div>
//     </div>
//   );
// };

// export default ProductCard;


// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import React, { useState } from "react";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { auth, firestore } from "../../FirebaseConfig";
// import { motion } from "framer-motion";

// const ProductCard = ({ data }) => {
//   const navigate = useNavigate();

//   const isDiscounted = data.prices?.productDiscount > 0;
//   const isInStock = data.stock > 0;

//   const [isImageLoading, setIsImageLoading] = useState(true);
//   const [isAddingToCart, setIsAddingToCart] = useState(false);

//   const handleProduct = () => {
//     navigate(`/product/${data.id}`);
//   };

//   const handleAddToCart = async (product, id) => {
//     if (!auth.currentUser) {
//       toast.error("Please log in to add items to your cart.");
//       return;
//     }

//     if (product.stock < 1 || isAddingToCart) return;

//     const userId = auth.currentUser.uid;
//     const cartRef = doc(firestore, "customers", userId);

//     setIsAddingToCart(true);
//     const loadingToastId = toast.loading("Adding item...");

//     try {
//       const cartSnap = await getDoc(cartRef);
//       let updatedCart = { items: [] };

//       if (cartSnap.exists()) {
//         updatedCart = cartSnap.data() || { items: [] };
//       }

//       if (!Array.isArray(updatedCart.items)) {
//         updatedCart.items = [];
//       }

//       const existingItemIndex = updatedCart.items.findIndex(
//         (item) => item.productId === id
//       );

//       if (existingItemIndex !== -1) {
//         updatedCart.items[existingItemIndex].quantity += 1;
//       } else {
//         updatedCart.items.push({ productId: id, quantity: 1 });
//       }

//       if (cartSnap.exists()) {
//         await updateDoc(cartRef, updatedCart);
//       } else {
//         await setDoc(cartRef, updatedCart);
//       }

//       toast.dismiss(loadingToastId);
//       toast.success("Item added to cart!");
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//       toast.dismiss(loadingToastId);
//       toast.error("Error adding item to cart. Please try again.");
//     } finally {
//       setIsAddingToCart(false);
//     }
//   };

//   const effectivePrice =
//     data.prices?.productPrice - (data.prices?.productDiscount || 0);

//   const discountPercent =
//     isDiscounted && data.prices?.productPrice > 0
//       ? Math.round(
//           (data.prices.productDiscount / data.prices.productPrice) * 100
//         )
//       : 0;

//   return (
//     <motion.div
//       onClick={handleProduct}
//       whileHover={{ y: -4, scale: 1.02 }}
//       whileTap={{ scale: 0.98 }}
//       className="bg-white bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl shadow-sm hover:shadow-xl transition-all cursor-pointer w-full max-w-[280px] pb-4 border border-gray-100/70"
//     >
//       {/* Image Section */}
//       {/* <div className="relative w-full flex justify-center items-center  rounded-t-2xl overflow-hidden ${
//         isImageLoading ? 'h-[200px]' : 'h-auto'}`"> */}

//        <div className={`relative w-full flex justify-center items-center  rounded-md ${
//         isImageLoading ? 'h-[200px]' : 'h-auto'}`}>  
//         {/* Shimmer Skeleton */}
//         {isImageLoading && (
//           <div className="absolute inset-0 bg-gray-300 animate-pulse rounded-md"></div>
//         )}

//         {isImageLoading && (
//           <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse" />
//         )}

//         <img
//           src={data.thumbnail}
//           alt={data.name}
//           loading="lazy"
//           decoding="async"
//           className={`w-full h-full object-contain  transition-opacity duration-700 ease-in-out ${
//             isImageLoading ? "opacity-0" : "opacity-100"
//           }`}
//           onLoad={() => setIsImageLoading(false)}
//           onError={() => setIsImageLoading(false)}
//         />

//         {/* Status / Tag Badge */}
//         {data.status !== "Normal" && (
//           <div
//             className={`absolute top-2 left-2 px-3 py-1 rounded-full text-[10px] font-semibold tracking-wide uppercase ${
//               isInStock ? "bg-red-500 text-white" : "bg-gray-400 text-white"
//             }`}
//           >
//             {isInStock ? data.status : "Out of Stock"}
//           </div>
//         )}

//         {/* Discount Badge */}
//         {isDiscounted && (
//           <div className="absolute top-2 right-2 px-2 py-1 rounded-full text-[10px] font-bold bg-emerald-600 text-white shadow-sm">
//             -{discountPercent}% OFF
//           </div>
//         )}
//       </div>

//       {/* Details Section */}
//       <div className="px-3 bg-gradient-to-br mt-2 from-amber-50 to-yellow-50  text-center">
//         <h3 className="text-s font-semibold text-gray-800 truncate">
//           {data.name}
//         </h3>
//         {data.category && (
//           <p className="text-xs text-gray-500 mt-0.5 truncate">
//             {data.category}
//           </p>
//         )}

//         {/* Price */}
//         <div className="mt-2 flex items-center justify-center space-x-2">
//           {isDiscounted && (
//             <span className="text-gray-400 line-through text-xs">
//               ₹{data.prices.productPrice}
//             </span>
//           )}
//           <span className="text-amber-700 font-bold text-lg">
//             ₹{effectivePrice}
//           </span>
//         </div>

//         {/* Optional small stock info */}
//         <div className="mt-1 text-[11px] text-gray-400">
//           {data.stock > 5
//             ? "In stock"
//             : data.stock > 0
//             ? `Only ${data.stock} left`
//             : "Currently unavailable"}
//         </div>

//         {/* Add to Cart Button */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             handleAddToCart(data, data.id);
//           }}
//           disabled={data.stock < 1 || isAddingToCart}
//           className={`mt-3 w-full px-4 py-2 rounded-full text-sm font-semibold flex items-center justify-center gap-2
//             ${
//               data.stock < 1
//                 ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                 : "bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm"
//             }
//             disabled:opacity-70 disabled:cursor-not-allowed transition-colors`}
//         >
//           {data.stock < 1
//             ? "Out of Stock"
//             : isAddingToCart
//             ? "Adding..."
//             : "Add 🍯"}
//         </button>
//       </div>
//     </motion.div>
//   );
// };

// export default React.memo(ProductCard);



// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import React, { useState } from "react";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { auth, firestore } from "../../FirebaseConfig";
// import { motion } from "framer-motion";

// const ProductCard = ({ data }) => {
//   const navigate = useNavigate();

//   const isDiscounted = data.prices?.productDiscount > 0;
//   const isInStock = data.stock > 0;

//   const [isImageLoading, setIsImageLoading] = useState(true);
//   const [isAddingToCart, setIsAddingToCart] = useState(false);

//   const handleProduct = () => {
//     navigate(`/product/${data.id}`);
//   };

//   const handleAddToCart = async (product, id) => {
//     if (!auth.currentUser) {
//       toast.error("Please log in to add items to your cart.");
//       return;
//     }

//     if (product.stock < 1 || isAddingToCart) return;

//     const userId = auth.currentUser.uid;
//     const cartRef = doc(firestore, "customers", userId);

//     setIsAddingToCart(true);
//     const loadingToastId = toast.loading("Adding item...");

//     try {
//       const cartSnap = await getDoc(cartRef);
//       let updatedCart = { items: [] };

//       if (cartSnap.exists()) {
//         updatedCart = cartSnap.data() || { items: [] };
//       }

//       if (!Array.isArray(updatedCart.items)) {
//         updatedCart.items = [];
//       }

//       const existingItemIndex = updatedCart.items.findIndex(
//         (item) => item.productId === id
//       );

//       if (existingItemIndex !== -1) {
//         updatedCart.items[existingItemIndex].quantity += 1;
//       } else {
//         updatedCart.items.push({ productId: id, quantity: 1 });
//       }

//       if (cartSnap.exists()) {
//         await updateDoc(cartRef, updatedCart);
//       } else {
//         await setDoc(cartRef, updatedCart);
//       }

//       toast.dismiss(loadingToastId);
//       toast.success("Item added to cart!");
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//       toast.dismiss(loadingToastId);
//       toast.error("Error adding item to cart. Please try again.");
//     } finally {
//       setIsAddingToCart(false);
//     }
//   };

//   const effectivePrice =
//     data.prices?.productPrice - (data.prices?.productDiscount || 0);

//   const discountPercent =
//     isDiscounted && data.prices?.productPrice > 0
//       ? Math.round(
//           (data.prices.productDiscount / data.prices.productPrice) * 100
//         )
//       : 0;

//   const rating = data.rating || 0;
//   const ratingCount = data.ratingCount || 0;
//   const hasRating = rating > 0 && ratingCount > 0;

//   return (
//     <motion.div
//       onClick={handleProduct}
//       whileHover={{ y: -4, scale: 1.02 }}
//       whileTap={{ scale: 0.98 }}
//       className="bg-white bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl shadow-sm hover:shadow-xl transition-all cursor-pointer w-full max-w-[280px] pb-4 border border-gray-100/70"
//     >
//       {/* Image Section */}
    


// <div
//   className={`relative w-full flex justify-center items-center rounded-md ${
//     isImageLoading ? "h-[200px]" : "h-auto"
//   }`}
// >
//   {/* Shimmer Skeleton */}
//   {isImageLoading && (
//     <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse rounded-md" />
//   )}

//   <img
//     src={data.thumbnail}
//     alt={data.name}
//     loading="lazy"
//     decoding="async"
//     className={`w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
//       isImageLoading ? "opacity-0" : "opacity-100"
//     }`}
//     onLoad={() => setIsImageLoading(false)}
//     onError={() => setIsImageLoading(false)}
//   />

//   {/* Status / Tag Badge */}
//   {data.status !== "Normal" && (
//     <div
//       className={`absolute top-2 left-2 px-3 py-1 rounded-full text-[10px] font-semibold tracking-wide uppercase ${
//         isInStock ? "bg-red-500 text-white" : "bg-gray-400 text-white"
//       }`}
//     >
//       {isInStock ? data.status : "Out of Stock"}
//     </div>
//   )}

//   {/* Discount Badge */}
//   {isDiscounted && (
//     <div className="absolute top-2 right-[68px] px-2 py-1 rounded-full text-[10px] font-bold bg-emerald-600 text-white shadow-sm">
//       -{discountPercent}% OFF
//     </div>
//   )}

//   {/* ⭐ Rating Badge — Premium Top-Right */}
//   {hasRating && (
//     <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full shadow-md border border-amber-100">
//       <span className="text-amber-500 text-sm font-bold">★</span>
//       <span className="text-xs font-semibold text-gray-800">{rating.toFixed(1)}</span>
//       <span className="text-[10px] text-gray-500">({ratingCount})</span>
//     </div>
//   )}
// </div>

//       {/* Details Section */}
//       <div className="px-3 bg-gradient-to-br mt-2 from-amber-50 to-yellow-50 text-center">
//         <h3 className="text-sm font-semibold text-gray-800 truncate">
//           {data.name}
//         </h3>
//         {data.category && (
//           <p className="text-xs text-gray-500 mt-0.5 truncate">
//             {data.category}
//           </p>
//         )}

//         {/* Rating pill – ONE star, clean & responsive */}
//         {/* {hasRating && (
//           <div className="mt-1 flex justify-center">
//             <div className="inline-flex items-center gap-1 rounded-full bg-white/90 px-2.5 py-1 shadow-sm border border-amber-100">
//               <span className="flex h-5 w-5 items-center justify-center rounded-full bg-amber-500 text-[10px] text-white">
//                 ★
//               </span>
//               <span className="text-xs md:text-sm font-semibold text-gray-800">
//                 {rating.toFixed(1)}
//               </span>
//               <span className="text-[10px] md:text-xs text-gray-500">
//                 ({ratingCount})
//               </span>
//             </div>
//           </div>
//         )} */}


//         {/* Price */}
//         <div className="mt-2 flex items-center justify-center space-x-2">
//           {isDiscounted && (
//             <span className="text-gray-400 line-through text-xs">
//               ₹{data.prices.productPrice}
//             </span>
//           )}
//           <span className="text-amber-700 font-bold text-lg">
//             ₹{effectivePrice}
//           </span>
//         </div>

//         {/* Optional small stock info */}
//         {data.stock < 5 &&
//         <div className="mt-1 text-[11px] text-gray-400">
//           {data.stock > 5
//             ? "In stock"
//             : data.stock > 0
//             ? `Only ${data.stock} left`
//             : "Currently unavailable"}
//         </div>
// }
//         {/* Add to Cart Button */}
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             handleAddToCart(data, data.id);
//           }}
//           disabled={data.stock < 1 || isAddingToCart}
//           className={`mt-3 w-full px-4 py-2 rounded-full text-sm font-semibold flex items-center justify-center gap-2
//             ${
//               data.stock < 1
//                 ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                 : "bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm"
//             }
//             disabled:opacity-70 disabled:cursor-not-allowed transition-colors`}
//         >
//           {data.stock < 1
//             ? "Out of Stock"
//             : isAddingToCart
//             ? "Adding..."
//             : "Add 🍯"}
//         </button>
//       </div>
//     </motion.div>
//   );
// };

// export default React.memo(ProductCard);


import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { auth, firestore } from "../../FirebaseConfig";
import { motion } from "framer-motion";
// Lucide Icons
import { Sparkles, Leaf, Zap, Clock, Ban, Star } from "lucide-react";

const ProductCard = ({ data }) => {
  const navigate = useNavigate();

  const isDiscounted = data.prices?.productDiscount > 0;
  const isInStock = data.stock > 0;

  const [isImageLoading, setIsImageLoading] = useState(true);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  // Status Configuration for UI
  const getStatusInfo = (status) => {
    if (!isInStock) return { label: "Out of Stock", icon: <Ban size={12} />, color: "bg-gray-500/90" };
    
    switch (status) {
      case "Must Try": return { label: status, icon: <Sparkles size={12} />, color: "bg-orange-500/90" };
      case "Season": return { label: status, icon: <Leaf size={12} />, color: "bg-emerald-500/90" };
      case "Selling fast": return { label: status, icon: <Zap size={12} />, color: "bg-amber-500/90" };
      case "Upcoming": return { label: status, icon: <Clock size={12} />, color: "bg-blue-500/90" };
      default: return null;
    }
  };

  const statusInfo = (data.status && data.status !== "Normal") || !isInStock ? getStatusInfo(data.status) : null;

  const handleProduct = () => {
    navigate(`/product/${data.id}`);
  };

  const handleAddToCart = async (product, id) => {
    if (!auth.currentUser) {
      toast.error("Please log in to add items to your cart.");
      return;
    }

    if (product.stock < 1 || isAddingToCart) return;

    const userId = auth.currentUser.uid;
    const cartRef = doc(firestore, "customers", userId);

    setIsAddingToCart(true);
    const loadingToastId = toast.loading("Adding item...");

    try {
      const cartSnap = await getDoc(cartRef);
      let updatedCart = { items: [] };

      if (cartSnap.exists()) {
        updatedCart = cartSnap.data() || { items: [] };
      }

      if (!Array.isArray(updatedCart.items)) {
        updatedCart.items = [];
      }

      const existingItemIndex = updatedCart.items.findIndex(
        (item) => item.productId === id
      );

      if (existingItemIndex !== -1) {
        updatedCart.items[existingItemIndex].quantity += 1;
      } else {
        updatedCart.items.push({ productId: id, quantity: 1 });
      }

      if (cartSnap.exists()) {
        await updateDoc(cartRef, updatedCart);
      } else {
        await setDoc(cartRef, updatedCart);
      }

      toast.dismiss(loadingToastId);
      toast.success("Item added to cart!");
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.dismiss(loadingToastId);
      toast.error("Error adding item to cart. Please try again.");
    } finally {
      setIsAddingToCart(false);
    }
  };

  const effectivePrice = data.prices?.productPrice - (data.prices?.productDiscount || 0);
  const discountPercent = isDiscounted && data.prices?.productPrice > 0
      ? Math.round((data.prices.productDiscount / data.prices.productPrice) * 100) : 0;

  const rating = data.rating || 0;
  const ratingCount = data.ratingCount || 0;
  const hasRating = rating > 0 && ratingCount > 0;

  return (
    <motion.div
      onClick={handleProduct}
      whileHover={{ y: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className="bg-white bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl shadow-sm hover:shadow-xl transition-all cursor-pointer w-full max-w-[280px] pb-4 border border-gray-100/70"
    >
      {/* Image Section - Logic Unchanged */}
      <div
        className={`relative w-full flex justify-center items-center rounded-md ${
          isImageLoading ? "h-[200px]" : "h-auto"
        }`}
      >
        {isImageLoading && (
          <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse rounded-md" />
        )}

        <img
          src={data.thumbnail}
          alt={data.name}
          loading="lazy"
          decoding="async"
          className={`w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
            isImageLoading ? "opacity-0" : "opacity-100"
          }`}
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />

        {/* Status Badge — Bottom Left with Lucide Icon */}
        {statusInfo && (
          <div className={`absolute bottom-2 left-2 flex items-center gap-1 px-2 py-1 rounded-md text-[9px] font-bold text-white shadow-sm backdrop-blur-sm uppercase tracking-wider ${statusInfo.color}`}>
            {statusInfo.icon}
            {statusInfo.label}
          </div>
        )}

        {/* Discount Badge — Top Right */}
        {isDiscounted && (
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[10px] font-bold bg-emerald-600 text-white shadow-sm">
            -{discountPercent}%
          </div>
        )}

        {/* ⭐ Rating Badge — Bottom Right, Transparent & Smaller */}
        {hasRating && (
          <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-white/20 backdrop-blur-[2px] px-1.5 py-0.5 rounded-md border border-white/30 shadow-sm">
            <Star size={10} className="fill-amber-500 text-amber-500" />
            <span className="text-[10px] font-bold text-gray-800">{rating.toFixed(1)}</span>
            <span className="text-[9px] text-gray-500">({ratingCount})</span>
          </div>
        )}
      </div>

      {/* Details Section */}
      <div className="px-3 bg-gradient-to-br mt-2 from-amber-50 to-yellow-50 text-center">
        <h3 className="text-sm font-semibold text-gray-800 truncate">
          {data.name}
        </h3>
        {data.category && (
          <p className="text-xs text-gray-500 mt-0.5 truncate">
            {data.category}
          </p>
        )}

        {/* Price */}
        <div className="mt-2 flex items-center justify-center space-x-2">
          {isDiscounted && (
            <span className="text-gray-400 line-through text-xs">
              ₹{data.prices.productPrice}
            </span>
          )}
          <span className="text-amber-700 font-bold text-lg">
            ₹{effectivePrice}
          </span>
        </div>

        {/* Stock info */}
        {data.stock < 8 && (
          <div className="mt-1 text-[11px] text-gray-400">
            {data.stock > 0 ? `Only ${data.stock} left` : "Currently unavailable"}
          </div>
        )}

        {/* Add to Cart Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleAddToCart(data, data.id);
          }}
          disabled={data.stock < 1 || isAddingToCart}
          className={`mt-3 w-full px-4 py-2 rounded-full text-sm font-semibold flex items-center justify-center gap-2
            ${
              data.stock < 1
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm"
            }
            disabled:opacity-70 disabled:cursor-not-allowed transition-colors`}
        >
          {data.stock < 1 ? "Out of Stock" : isAddingToCart ? "Adding..." : "Add 🍯"}
        </button>
      </div>
    </motion.div>
  );
};

export default React.memo(ProductCard);